'use strict';

var _ = require('underscore'),
    AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    ContextMenuTypes = require('../constants/ContextMenuTypes'),
    invariant = require('react/lib/invariant'),
    assign = require('react/lib/Object.assign');

var ContextMenuActionCreators = {
  showContextMenu(id, anchorEl, options) {
    invariant(
      ContextMenuTypes.hasOwnProperty(id),
      'showContextMenu() accepts a constant from ContextMenuTypes. You passed %s',
      id
    );

    var anchorRect = _.pick(
      anchorEl.getBoundingClientRect(),
      'top', 'bottom', 'right', 'left', 'width', 'height'
    );

    _.each(anchorRect, (val, key) => {
      anchorRect[key] = Math.round(val);
    });

    AppDispatcher.handleViewAction({
      type: ActionTypes.SHOW_CONTEXT_MENU,
      contextMenu: assign({ id: id, anchorRect: anchorRect }, options)
    });
  },

  hideContextMenu() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.HIDE_CONTEXT_MENU
    });
  }
};

module.exports = ContextMenuActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/ContextMenuActionCreators.js
 **/